function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useRef, useState } from 'react';
import SortingIcon from './SortIcon';
import styles from './sorting.less';
import SortMobileIcon from './SortMobileIcon';
import closeDropdown from '../common/closeDropdown';
export var sortColumns = {
  standard: 'weights',
  rating: 'ratings'
};
export var initialSortingOptions = [{
  id: 1,
  name: 'Standardsortierung',
  sortBy: sortColumns.standard,
  sortOrder: 'ASC',
  selected: true
}, {
  id: 2,
  name: 'Bewertung (höchste zuerst)',
  sortBy: sortColumns.rating,
  sortOrder: 'DESC'
}];
var Sorting = function Sorting(_ref) {
  var initialSelectedSortingOption = _ref.initialSelectedSortingOption,
    onSortOrderChange = _ref.onSortOrderChange;
  if (!initialSelectedSortingOption) {
    return null;
  }
  var _useState = useState(initialSortingOptions),
    _useState2 = _slicedToArray(_useState, 2),
    sortingOptions = _useState2[0],
    setSortingOptions = _useState2[1];
  var _useState3 = useState(initialSelectedSortingOption),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedSortingOption = _useState4[0],
    setSelectedSortingOption = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    showDropDown = _useState6[0],
    setShowDropdown = _useState6[1];
  var sortDropDownRef = useRef(null);
  var _closeDropdown = closeDropdown(sortDropDownRef, setShowDropdown),
    handleDropdown = _closeDropdown.handleDropdown;
  useEffect(function () {
    return handleDropdown(showDropDown);
  }, [showDropDown]);
  var toggleDropdown = function toggleDropdown(event) {
    event === null || event === void 0 || event.preventDefault();
    setShowDropdown(!showDropDown);
  };
  var onSelected = function onSelected(selectedSortingOption) {
    var modifiedSortingOptions = sortingOptions.map(function (sortingOption) {
      if (sortingOption.id === selectedSortingOption.id) {
        return _objectSpread(_objectSpread({}, sortingOption), {}, {
          selected: true
        });
      }
      return _objectSpread(_objectSpread({}, sortingOption), {}, {
        selected: false
      });
    });
    setSelectedSortingOption(selectedSortingOption);
    setSortingOptions(modifiedSortingOptions);
    toggleDropdown();
    onSortOrderChange({
      sortBy: selectedSortingOption.sortBy,
      order: selectedSortingOption.sortOrder
    });
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    ref: sortDropDownRef
  }, /*#__PURE__*/React.createElement("span", {
    className: "lap-hide palm-hide"
  }, " Sortiert nach: "), /*#__PURE__*/React.createElement("button", {
    "data-testid": "sort-button",
    type: "button",
    "aria-expanded": showDropDown,
    onClick: toggleDropdown,
    className: "link-text ".concat(styles.sortingLabel, " label  palm-hide")
  }, /*#__PURE__*/React.createElement("span", {
    className: "margin-right-xs palm-hide"
  }, /*#__PURE__*/React.createElement(SortingIcon, null)), /*#__PURE__*/React.createElement("span", {
    "data-testid": "selected-option",
    className: "margin-right-xs"
  }, selectedSortingOption.name)), /*#__PURE__*/React.createElement("button", {
    "data-testid": "sort-mobile-button",
    type: "button",
    "aria-label": "Sortierung: ".concat(selectedSortingOption.name),
    "aria-expanded": showDropDown,
    onClick: toggleDropdown,
    className: "link-text ".concat(styles.sortingLabel, " desk-hide lap-hide label")
  }, /*#__PURE__*/React.createElement("span", {
    className: "margin-right-xs"
  }, /*#__PURE__*/React.createElement(SortMobileIcon, null)))), showDropDown && /*#__PURE__*/React.createElement("div", {
    className: "drop-down-layer ".concat(styles.sortingDropdown, "  border background-white align-left")
  }, sortingOptions.map(function (sortingOption) {
    return /*#__PURE__*/React.createElement("div", {
      "data-testid": "entry",
      key: sortingOption.id,
      "data-selected": sortingOption.selected,
      onClick: function onClick() {
        return onSelected(sortingOption);
      },
      className: "".concat(styles.entry, " ").concat(sortingOption.selected ? styles.selected : '')
    }, sortingOption.name);
  })));
};
export default Sorting;